module.exports = __webpack_public_path__ + "media/images/logo-black-ab256d6c08bb59acaa27dc244dbefbd1.png";